import { jsx as _jsx } from "react/jsx-runtime";
import './FormGrid.css';
const FormGrid = ({ children, layout = '2col', className }) => {
    return _jsx("section", { className: `formGrid l${layout} ${className !== null && className !== void 0 ? className : ''}`, children: children });
};
export default FormGrid;
